// extracted by mini-css-extract-plugin
export default {"resources_help":"ResourcesHelp_resources_help__ATMXZ"};